import getTimeZoneOffsetInMin from '@/utils/getTimeZoneOffsetInMin';

export const moveDay = (currentDay: number, amount: -1 | 0 | 1) => {
  const targetDay = currentDay + amount;
  return targetDay < 0 ? 6 : targetDay % 7;
};

export const getDayDifference = (localDate: Date, localTimeZone: string, targetTimeZone = 'utc') => {
  const currentTimeZoneOffsetInMin = getTimeZoneOffsetInMin(localTimeZone, new Date());
  const targetTimeZoneOffsetInMin = getTimeZoneOffsetInMin(targetTimeZone, new Date());

  const oneMinInMillisec = 60000;
  const targetDate = new Date(
    localDate.getTime() + (targetTimeZoneOffsetInMin - currentTimeZoneOffsetInMin) * oneMinInMillisec,
  );

  const localDay = localDate.getDay();
  const targetDay = targetDate.getDay();

  if (targetDay === 6 && localDay === 0) {
    return -1;
  }

  if (targetDay === 0 && localDay === 6) {
    return 1;
  }

  return targetDate.getDay() - localDate.getDay();
};

export const getTimeFromHourAndMinute = (hour: number, minute: number): string => {
  return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
};
